import { ActivatedRoute, Router } from "@angular/router";
import { ConstantConfig } from "../config/constant.config";
import { ClientDetailService } from "../services/client-detail-service";
import { UserService } from "../services/user.service";

export class ClientUtils {

    constructor() { }

    public static getClientSlug(activatedRoute: ActivatedRoute, router: Router) {
        let clientId;
        activatedRoute.paramMap.subscribe(params => {
            clientId = params.get('clientId') || '';
        });
        if (!clientId) {
            let url = router.url.split("/");
            if (url.length > 1) {
                clientId = url[1];
            }
        }
        const windowURL = window.location.pathname.split("/");
        const clientIDFromURL = (windowURL.length > 1) ? windowURL[1] : '';
        return clientId || sessionStorage[ConstantConfig.CLIENT_SLUG] || clientIDFromURL;
    }

    public static isLoginAsClient(clientDetailService: ClientDetailService, userService: UserService) {
        return clientDetailService.IS_DEFAULT == 'NO' && userService.getLoginType(clientDetailService.CLIENT_ID);
    }
    
}
